import app from "reactPath/constants/app";
import OsVersion from "./osVersion";

/**
 * 国际化部分工具
 * @param locale
 * @returns {string}
 */
export function templateStr(localeMessage) {
  if (!localeMessage) {
    return "";
  }
  let argParams = Array.prototype.slice.call(arguments, 1),
    len = argParams.length;

  let newStr = localeMessage.replace(/\{\d\}/g, function (match) {
    let i = match.match(/\d/)[0] - 0;
    return argParams[i] ?? "";
  });

  let data = argParams[len - 1];
  if (data && typeof data === "object") {
    newStr = newStr.replace(/\{([^}]+)\}/g, function (match, field) {
      let fieldArr = field.split(".");
      let o = data;
      for (let i = 0, len = fieldArr.length; i < len; i++) {
        let key = fieldArr[i];
        o = o?.[key];
      }
      return o === undefined ? match : o;
    });
  }
  return newStr;
}
/* 对BluramsGrand这样的词汇进行替换 */
export function templateAppCloud(localeMessage) {
  let { customizedConfig } = window.SYSTEM_CONFIG || {};
  let { appName: configAppName } = customizedConfig || {};
  let { appName = configAppName } = window.PAGE_PARAMS || {};
  let placeReplace = "BluramsGuard";
  if (app.isBoyKeepApp()) {
    placeReplace = "KeepCloud";
  }
  if (app.isIeCameApp()) {
    placeReplace = "ieCame Cloud";
  }
  return templateStr(localeMessage, { appCloudName: placeReplace, appName });
}
/**
 * 使用app配置信息，填充字符串中的占位符
 * @param {string} localeMessage
 * @returns
 */
export function templateWithAppConfig(localeMessage) {
  if (!localeMessage) {
    return "";
  }
  let { locale = "" } = window.LOCALE_DATA || {};
  let { customizedConfig } = window.SYSTEM_CONFIG || {};
  let {
    supportEmail,
    appName: configAppName,
    userAgreement,
    wechatSubscription,
  } = customizedConfig || {};
  let { appName = configAppName } = window.PAGE_PARAMS || {};
  let [language, country] = locale.split(/-|_/g);
  language = language.toLowerCase();
  if (country) locale = `${language}_${country.toLowerCase()}`;

  let companyKey = "company";
  let shortCompanyKey = "shortCompany";
  let userAgreeCompany =
    userAgreement[companyKey + "_" + locale] ||
    userAgreement[companyKey + "_" + language] ||
    userAgreement[companyKey];
  let userAgreeShortCompany =
    userAgreement[shortCompanyKey + "_" + locale] ||
    userAgreement[shortCompanyKey + "_" + language] ||
    userAgreement[shortCompanyKey];
  let appConfig = {
    appName,
    supportEmail,
    userAgreeCompany,
    userAgreeShortCompany,
    wechatSubscription,
  };
  return templateStr(localeMessage, appConfig);
}

/**
 * Object转成query字符串
 * @param {object} obj
 * @param {object|boolean} options  {excludeRandomStr: 是否去掉随机数，默认false；prefixChar: 返回字符串前拼接字符，默认?}
 * @returns
 */
export function objToUrl(obj, options = {}) {
  if (!obj) return "";

  if (typeof options === "boolean") {
    options = { excludeRandomStr: options };
  }
  const { excludeRandomStr = false, prefixChar = "?" } = options;

  const url = Object.entries(obj)
    .map(([key, val]) => {
      if (val === undefined || val === null) return;
      if (typeof val === "object") val = JSON.stringify(val);
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    })
    .filter(Boolean);

  if (!url.length) return "";

  if (!excludeRandomStr)
    url.push("____r=" + Math.random().toString().substring(2) + Date.now());
  return prefixChar + url.join("&");
}

export function decodeURIComponentFromApp(string) {
  if (OsVersion.isAndroid) {
    string = string.replace(/\+/g, "%20");
  }
  return decodeURIComponent(string);
}

/**
 * 重复拼接字符串
 * @param {*} source
 * @param {*} length
 * @returns
 */
export function repeat(source, length) {
  return new Array(length > -1 ? length + 1 : 0).join(source);
}

/**
 * 将字符串前面填充0
 * @param {*} source
 * @param {*} length
 * @returns
 */
export function pad(source, length) {
  return repeat("0", length - (source + "").length) + source;
}
/**
 * 解析时区+08:00格式
 * @param {*} timezone
 * @returns
 */
export function timezone2Offset(timezone) {
  let offsetSeconds = new Date().getTimezoneOffset() * -60;
  if (!timezone) return offsetSeconds;
  try {
    timezone = timezone.toLowerCase().trim();
    let offset;
    let zoneMatch = timezone.match(/([+|-]?)(\d{1,2}):(\d{2})/);

    if (zoneMatch) {
      let [zone, symbolChar, hour, minute] = zoneMatch;
      hour = parseInt(hour, 10);
      minute = parseInt(minute, 10);

      offset = hour * 3600 + minute * 60;
      if (symbolChar === "-") offset *= -1;
    }
    if (!offset) {
      offset = timezone.trim().split("offset")[1];
      if (!offset) {
        throw `timezone [${timezone}] has not offset!`;
      }

      offset = offset.trim().split(/\s/)[0];
      offset = parseInt(offset, 10);
    }
    if (!isNaN(offset)) {
      offsetSeconds = offset;
    }
  } catch (e) {
    console.error(e);
  }
  return offsetSeconds;
}

export function offset2Timezone(offsetSeconds) {
  offsetSeconds = offsetSeconds ?? new Date().getTimezoneOffset() * -60;
  let timezone = offsetSeconds / 3600;
  let timezoneStr = timezone > 0 ? "+" : "-";
  const timezoneAbs = Math.abs(timezone);
  const h = Math.floor(timezoneAbs);
  timezoneStr += pad(h, 2) + ":" + pad(Math.round((timezoneAbs - h) * 60), 2);
  return timezoneStr;
}

/**
 * 格式化日期
 * @param {string} pattern 格式 YYYY-MM-dd HH:ii:ss Z w
 * @param {Date|number}source 时间戳
 * @param {boolean} useUTC 是否使用utc时间
 * @returns {*}
 */
export const date_format = (pattern, source, useUTC = false) => {
  if (!isNaN(parseInt(source, 10))) source = new Date(parseInt(source, 10));
  source = source || new Date();
  if ("string" != typeof pattern) {
    return source.toString();
  }

  function replacer(patternPart, result) {
    pattern = pattern.replace(patternPart, result + "");
  }

  let year = useUTC ? source.getUTCFullYear() : source.getFullYear(),
    month = (useUTC ? source.getUTCMonth() : source.getMonth()) + 1,
    date2 = useUTC ? source.getUTCDate() : source.getDate(),
    hours = useUTC ? source.getUTCHours() : source.getHours(),
    minutes = useUTC ? source.getUTCMinutes() : source.getMinutes(),
    seconds = useUTC ? source.getUTCSeconds() : source.getSeconds(),
    weekDay = useUTC ? source.getUTCDay() : source.getDay();

  //星期日~星期六
  let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  let weekDays_EN = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  replacer(/yyyy|YYYY/g, pad(year, 4));
  replacer(/yy|YY/g, pad(year.toString().slice(2), 2));
  replacer(/MM/g, pad(month, 2));
  replacer(/M/g, month);
  replacer(/dd/g, pad(date2, 2));
  replacer(/d/g, date2);

  replacer(/HH/g, pad(hours, 2));
  replacer(/H/g, hours);
  replacer(/hh/g, pad(hours % 12, 2));
  replacer(/h/g, hours % 12);
  replacer(/ii/g, pad(minutes, 2));
  replacer(/i/g, minutes);
  replacer(/mm/g, pad(minutes, 2));
  replacer(/m/g, minutes);
  replacer(/ss/g, pad(seconds, 2));
  replacer(/s/g, seconds);
  replacer(/w|W/g, weekDays[weekDay]);
  replacer(/e|e/g, weekDays_EN[weekDay]);

  replacer(/Z|z/g, "UTC" + offset2Timezone(source.getTimezoneOffset() * -60));

  return pattern;
};

/**
 *
 * @param {*} time  HH:mm格式
 * @param {*} timeZone 时区+08:00格式
 * @returns
 */
export function getLocalTime(time, timeZone, dateTimeFormat = "HH:mm") {
  const offsetSeconds = timezone2Offset(timeZone);
  const localOffsetSeconds = timezone2Offset();
  const [h, m] = time.split(":");
  const date = new Date();
  date.setHours(+h, +m);
  return date_format(
    dateTimeFormat,
    date.getTime() + (localOffsetSeconds - offsetSeconds) * 1000
  );
}

/**
 *
 * @param {*} date  日期或时间戳(兼容秒与毫秒)
 * @param {*} distTZ  时区+08:00格式 或  offset(秒)
 * @param {*} srcTZ  时区+08:00格式 或  offset(秒)
 * @returns  时间戳(毫秒)
 */
export function convertTimeZone(date, distTZ, srcTZ) {
  if (Number.isInteger(date)) date = new Date(+timestamp_format(date));
  const distOffsetSeconds = Number.isInteger(distTZ)
    ? distTZ
    : timezone2Offset(distTZ);
  const srcOffsetSeconds = Number.isInteger(srcTZ)
    ? srcTZ
    : timezone2Offset(srcTZ);
  return date.getTime() + (srcOffsetSeconds - distOffsetSeconds) * 1000;
}

/**
 * 时间戳统一为毫秒计
 * @param timestamp
 */
export const timestamp_format = (timestamp) => {
  if (!timestamp) {
    return "";
  }
  timestamp = String(timestamp);
  if (timestamp.length == 13) {
    return timestamp;
  } else if (timestamp.length <= 10) {
    return timestamp + "000";
  }
};

/**
 * canary全局配置值处理
 * @param {*} key
 * @returns
 */
export function formatCanaryConfigValue(key) {
  let { canaryGlobalAttrs = {} } = window.self.SYSTEM_CONFIG || {};
  let configValueStr = canaryGlobalAttrs[key] || "";
  configValueStr = configValueStr.trim();
  if (!configValueStr) return;
  try {
    if (configValueStr.startsWith("{") || configValueStr.startsWith("["))
      return JSON.parse(configValueStr);
  } catch (e) {
    //console.error(e);
  }
  return configValueStr
    .split(/[,;\n]/g)
    .map((val) => val.trim())
    .filter(Boolean);
}
